import React from "react";

const MicrosoftIntegration = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#5059C9"
            d="M24.32 14.163h8.266c.781 0 1.414.633 1.414 1.414v7.529a5.197 5.197 0 0 1-5.197 5.196h-.024a5.197 5.197 0 0 1-5.198-5.196v-8.204c0-.408.331-.74.74-.74ZM29.907 12.674a3.349 3.349 0 1 0 0-6.697 3.349 3.349 0 0 0 0 6.697Z"
        />
        <path
            fill="#7B83EB"
            d="M19.488 12.674a4.837 4.837 0 1 0 0-9.674 4.837 4.837 0 0 0 0 9.674ZM25.938 14.163H12.294a1.4 1.4 0 0 0-1.364 1.43v8.588a8.394 8.394 0 0 0 8.186 8.586 8.394 8.394 0 0 0 8.186-8.586v-8.587a1.399 1.399 0 0 0-1.364-1.431Z"
        />
        <path
            fill="#000"
            d="M19.86 14.163v12.033a1.37 1.37 0 0 1-1.361 1.362h-6.914a9.063 9.063 0 0 1-.655-3.379v-8.587a1.397 1.397 0 0 1 1.362-1.43h7.568Z"
            opacity={0.1}
        />
        <path
            fill="#000"
            d="M19.116 14.163V26.94a1.37 1.37 0 0 1-1.362 1.362h-5.819a9.648 9.648 0 0 1-.35-.744 7.396 7.396 0 0 1-.26-.744 9.064 9.064 0 0 1-.395-2.634v-8.588a1.397 1.397 0 0 1 1.362-1.43h6.824Z"
            opacity={0.2}
        />
        <path
            fill="#000"
            d="M19.116 14.163v11.29a1.372 1.372 0 0 1-1.361 1.36h-6.43a9.063 9.063 0 0 1-.395-2.633v-8.588a1.397 1.397 0 0 1 1.362-1.43h6.824Z"
            opacity={0.2}
        />
        <path
            fill="#000"
            d="M18.372 14.163v11.29a1.372 1.372 0 0 1-1.362 1.36h-5.685a9.063 9.063 0 0 1-.395-2.633v-8.588a1.397 1.397 0 0 1 1.362-1.43h6.08Z"
            opacity={0.2}
        />
        <path
            fill="#000"
            d="M19.86 10.315v2.345c-.126.007-.245.014-.372.014-.126 0-.245-.007-.372-.014a4.082 4.082 0 0 1-.744-.12 4.837 4.837 0 0 1-3.349-2.842 4.141 4.141 0 0 1-.238-.745h3.713c.752.003 1.36.611 1.362 1.362Z"
            opacity={0.1}
        />
        <path
            fill="#000"
            d="M19.116 11.06v1.6a4.083 4.083 0 0 1-.744-.12 4.837 4.837 0 0 1-3.349-2.842h2.731c.751.003 1.36.61 1.362 1.361Z"
            opacity={0.2}
        />
        <path
            fill="#000"
            d="M19.116 11.06v1.6a4.083 4.083 0 0 1-.744-.12 4.837 4.837 0 0 1-3.349-2.842h2.731c.751.003 1.36.61 1.362 1.361Z"
            opacity={0.2}
        />
        <path
            fill="#000"
            d="M18.372 11.06v1.48a4.837 4.837 0 0 1-3.349-2.842h1.987c.751.003 1.36.61 1.362 1.361Z"
            opacity={0.2}
        />
        <path
            fill="url(#a)"
            d="M3.364 9.698h13.644c.753 0 1.364.61 1.364 1.364v13.644c0 .753-.61 1.364-1.364 1.364H3.364C2.611 26.07 2 25.459 2 24.706V11.062c0-.754.61-1.364 1.364-1.364Z"
        />
        <path
            fill="#fff"
            d="M13.776 14.89H11.05v7.428H9.31V14.89H6.596V13.45h7.18v1.44Z"
        />
        <defs>
            <linearGradient
                id="a"
                x1={4.844}
                x2={15.528}
                y1={8.632}
                y2={27.136}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5A62C3" />
                <stop offset={0.5} stopColor="#4D55BD" />
                <stop offset={1} stopColor="#3940AB" />
            </linearGradient>
        </defs>

    </svg>
);

export default MicrosoftIntegration;
